import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import ListItemText from '@material-ui/core/ListItemText';

import { BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

class Index extends React.Component {
    render() {
        const { primary, secondary, intl } = this.props;
        return (
            <div
                className={'item-user-menu hand'}
                onClick={this.props.onClick}
                onKeyDown={this.props.onClick}
            >
                <ListItemText
                    primary={
                        primary === undefined ? undefined : intl.formatMessage({ id: primary })
                    }
                    secondary={
                        secondary === undefined ? undefined : intl.formatMessage({ id: secondary })
                    }
                    classes={{
                        primary: 'barlow_medium_subtitle c_dark_grey_blue',
                        secondary:
                            'barlow_regular_title c_slate_grey padding_top_18 padding_left_18 uppercase',
                    }}
                />
                {secondary === undefined ? <BlueRightArrowIcon color="primary" /> : <div />}
            </div>
        );
    }
}
Index.propTypes = {
    intl: intlShape.isRequired,
};

Index = injectIntl(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/navbar/user/Item.js